import { Card, CardBody, CircularProgress } from '@heroui/react'
import { useEffect, useState } from 'react'

export function PreloaderIndicator() {
  const [isPreloading, setIsPreloading] = useState(false)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (typeof window === 'undefined' || !navigator.serviceWorker) return
    function swMessageHandler(event) {
      if (!event.data || !event.data.type) return
      if (event.data.type === 'PRELOAD_PROGRESS') {
        setIsPreloading(true)
        setProgress(event.data.progress ?? 0)
      } else if (event.data.type === 'PRELOAD_DONE') {
        setIsPreloading(false)
        setProgress(100)
      } else if (event.data.type === 'PRELOAD_START') {
        setIsPreloading(true)
        setProgress(0)
      }
    }
    navigator.serviceWorker.addEventListener('message', swMessageHandler)
    return () => {
      navigator.serviceWorker.removeEventListener('message', swMessageHandler)
    }
  }, [])

  if (!isPreloading) return null
  return (
    <div className="fixed bottom-4 right-4 flex items-center justify-center cursor-default select-none loading-screen z-[100] pointer-events-none">
      <Card>
        <CardBody>
          <CircularProgress
            aria-label="Preloading..."
            color="secondary"
            showValueLabel={true}
            size="lg"
            value={progress}
          />
        </CardBody>
      </Card>
    </div>
  )
}
